import { NgOptimizedImage } from '@angular/common';
import { Component, EventEmitter, inject, Output, signal, viewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { LayoutService } from '../../../services/layout.service';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FiltersModal } from '../../../../features/filters/filters-modal/filters-modal';
import { Searchbar } from '../../../../features/filters/searchbar/searchbar';
import { MatMenuModule } from '@angular/material/menu';
import { AuthenticationService } from '../../../services/authentication.service';
import { EventsStore } from '../../../store/pns-filters.store';
import { UserStore } from '../../../store/user.store';
import { filter } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
  selector: 'dnv-navbar',
  imports: [
    NgOptimizedImage,
    MatIconModule,
    TranslatePipe,
    RouterLink,
    MatDialogModule,
    Searchbar,
    MatMenuModule,
    MatSidenavModule,
    MatButtonModule
  ],
  templateUrl: './navbar.html',
})
export class Navbar {
  public readonly searchbar = viewChild(Searchbar);

  @Output() menuToggle = new EventEmitter<void>();
  public layoutService = inject(LayoutService);
  private dialog = inject(MatDialog);
  private readonly store = inject(EventsStore);
  public authService = inject(AuthenticationService);
  public isAnyFilterActive = this.store.isAnyFilterActive;
  private readonly userStore = inject(UserStore);
  public currentUser = this.userStore.currentUser;

  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  titleKey = signal<string>('TITLE');
  isButtonMenuOpen = signal<boolean>(false);
  isMenuVisible = signal<boolean>(true);

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const child = this.getDeepestChild(this.activatedRoute);
        const data = child.snapshot.data;
        this.titleKey.set(data['title'] ?? 'TITLE');
      });
  }

  focusSearchbar(): void {
    if (this.layoutService.searchBarVisible()) {
      this.searchbar()?.focus();
    }
  }

  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  onMenuButtonClick(): void {
    this.isButtonMenuOpen.update(value => !value);
    this.menuToggle.emit();
  }

  closeMenu(): void {
    this.isButtonMenuOpen.set(false);
  }

  openFilterDialog(): void {
    const dialogRef = this.dialog.open(FiltersModal, {
      width: '500px',
    });
  }
}

